'use strict';

import React, { Component, useState, useEffect, useCallback, useRef, useDebugValue, useContext } from 'react';
import { render } from 'react-dom';
import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { MenuModule } from '@ag-grid-enterprise/menu';
// import Consignmentforceclose from '../m';
import DrawMap from '../common/drawmap';
import CommentActions from "../layouts/commentsComponent";
import ForceCloseSideBar from "./forceclosuresidebarcomponent";
import { AllModules, GridOptionsWrapper } from '@ag-grid-enterprise/all-modules';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import MarkDeliver from "../layouts/markDeliveredButton.js";
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import ConsignmentActions from '../manage/ConsignmentActionsComponent';
import CountUp from 'react-countup';
import SweetAlert from 'react-bootstrap-sweetalert';
import CSVFileValidator from 'csv-file-validator';
import { findTransporterByCode, normalizeTransporterCode } from "./sobTransporterLookup";
import Consignmentforceclose from '../manage/consignmentforceclose';
import UpdateButton from "./updatelmstates";
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import CellGraphComponent from './cellGraphComponent';
import $ from 'jquery';
import ColumnGroup from './columngroupComponent';
import { getDDMMYYYY, getHyphenYYYYMMDD, getHyphenDDMMMYYYYHHMM, getHyphenDDMMMYYYY, getHyphenYYYYMMDDHHMMSS, getHyphenDDMMYYYYHHMMSS, getDDMMYYYYHHMMSS, getYYYYMMDD, getYYYYMMDDHHMMSS } from '../common/utils';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { HardwareDesktopWindows } from 'material-ui/svg-icons';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from "@fullcalendar/timegrid";
import Showlmvalue from "./showlmvalue";
import { verifyext, verifycsvdata } from "../common/verifyext";
import XLSX from "xlsx/dist/xlsx.full.min.js";
import { LoadingPortContext, resolvePageAccess } from '../../context/LoadingPortContext';
import ActualSobConfigPanel from './actualSobConfigPanel';
// const $ = window.$;
window.jQuery = $;
window.$ = $;
var redirectURL = require('../redirectURL');
var moment = require('moment');
var filecontent = "";
var googleAnalytics = require("../common/googleanalytics");
var CELL_DIMENSION_SIZE = 90;

// Actual SOB is reported as a PERCENTAGE of the zone's (or hub's) own actual load. Both
// getActualSobPercentage and getActualHubSobPercentage return the CMT per (zone, transporter) in
// `load` together with a `zoneTotals` array, and the share is derived here.
function zoneTotalMap(zoneTotals) {
    var map = {};
    (zoneTotals || []).forEach(function (z) {
        if (z && z.zone !== undefined && z.zone !== null) {
            map[String(z.zone).toUpperCase()] = parseFloat(z.totalLoad) || 0;
        }
    });
    return map;
}

// A zone that carried no load has no share to divide - report 0 rather than dividing by zero.
function sharePercent(load, zoneTotal) {
    var value = parseFloat(load);
    var total = parseFloat(zoneTotal);
    if (!value || !total || total <= 0) {
        return 0;
    }
    return Number(((value / total) * 100).toFixed(2));
}





export default class LmCurrentShareOfBusiness extends Component {
    static contextType = LoadingPortContext;
    constructor(props, context) {
        super(props, context);
        this._lastLoadingPortCode = context ? context.loading_port_code : undefined;
        this.state = {
            modules: AllModules,
            defaultColDef: {
                sortable: true,
                filter: true,
                editable: true,
            },
            eventAction: null,
            show: false,
            frameworkComponents: {
                consignmentforceclose: Consignmentforceclose,
                consignmentActions: ConsignmentActions,
                UpdateButton: UpdateButton,
                MarkDeliver: MarkDeliver,
                commentActions: CommentActions,
                Showlmvalue: Showlmvalue
            },
            modified_by: "",
            basicTitle: '',
            reasonforceclose: "",
            bulkslide: "",
            file: "",
            uploadFile: "",
            basicType: "default",
            loadshow: 'show-n',
            forceCloseRowNode: "",
            forceclosedata: "",
            csvcontent: "",
            sliderForceCloseTranslate: "",
            overly: '',
            rowData: [],
            bulkslide: "",
            showDiv: "",
            uploadDivWidth: "",
            mapinfo: "",
            dealer: "",
            sliderCommentTranslate: "",
            commentsRowData: "",
            consignment_code: "",
            sliderRouteTranslate: "",
            maptruckno: "",
            routeTruck: "",
            rownode: "",
            googelRoutes: "",
            file: "",
            rowSelection: 'multiple',
            sliderForceCloseTranslate: "",
            maptruckno: "",
            rowModelhighchartoptionsType: 'enterprise',
            rowGroupPanelShow: 'always',
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: "agTotalAndFilteredRowCountComponent",
                        align: "left"
                    },
                    {
                        statusPanel: "agTotalRowCountComponent",
                        align: "center"
                    },
                    { statusPanel: "agFilteredRowCountComponent" },
                    { statusPanel: "agSelectedRowCountComponent" },
                    { statusPanel: "agAggregationComponent" }
                ]
            },
            paginationPageSize: 200,
            // Actual SOB configuration pop-up (the gear beside the title)
            sobConfigOpen: false,
            geofencelist: [],
            geoFenceData: "",
            sideBar: {
                toolPanels: [
                    {
                        id: "columns",
                        labelDefault: "Columns",
                        labelKey: "columns",
                        iconKey: "columns",
                        toolPanel: "agColumnsToolPanel"
                    },
                    {
                        id: "filters",
                        labelDefault: "Filters",
                        labelKey: "filters",
                        iconKey: "filter",
                        toolPanel: "agFiltersToolPanel"
                    }
                ]
            },
            animateRows: true,
            dept_code: "",
            pagetitle: "",
            markDeliverRowNode: "",
            markDeliverData: "",
            sliderMarkDeliverTranslate: "",
            csvData: 0,
            overly: "show-m",
            loadshow: "show-m",
            trnsportersList: [],
            statesList: [],
            vehicleList: [],
            showCalendar: "show-m",
            showGridData: "show-m",
            transdata: [],
            zoneTotals: [],
            zonesList: [],
            zoneStates: [],
            sliderType: 1,
            comp_code: "",
            lpNames: [],
            loading_port_code: "",
            data_type: 1,
            regularActive: "activet",
            truckActive: "",
            courierActive: "", airCourierActive: "",
            controller: {
                open: false
            }, selectedRows: [], errors: [], validData: []
            //components : {datepicker:getDatePicker()}
        }
        this.changeFileHandler = this.changeFileHandler.bind(this);
        this.uploadBulkFormHandler = this.uploadBulkFormHandler.bind(this);
        this.onCellClicked = this.onCellClicked.bind(this)
        this.onHeaderClicked = this.onHeaderClicked.bind(this)
        this.onLoadShowData = this.onLoadShowData.bind(this);
        this.createColumns = this.createColumns.bind(this);
        this.createRows = this.createRows.bind(this);
        this.checkFileData = this.checkFileData.bind(this);
        this.fileInputRef = React.createRef();
    }

    componentDidMount() {
        loadDateTimeScript();
        this.pageAccess();
    }
    async pageAccess() {
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m',
        })
        var currentUrl = this.props.match.path;
        var resolved = await resolvePageAccess(currentUrl, this.context);
        if (!resolved) {
            this.setState({ loadshow: 'show-n', overly: 'show-n' });
            return;
        }
        this._lastLoadingPortCode = resolved.loading_port_code;
        this.setState({
            pageAccess: resolved.pageAccess,
            loading_port_code: resolved.loading_port_code,
            comp_code: resolved.comp_code,
            lpNames: resolved.lpNames,
            loadshow: 'show-n',
            overly: 'show-n',
        });
        await this.onLoadShowData();
    }
    onLoadShowData = async () => {
        this.setState({
            loadshow: "show-m",
            overly: "show-m",
        })
        var loading_port_code = this.state.loading_port_code;
        var data_type = this.state.data_type;
        var params = {
            loading_port_code: loading_port_code,
            data_type: data_type, is_hub: 0,
            air_courier_transporter: this.state.airCourierActive == "activet" ? 1 : 0,
            is_air_courier: this.state.airCourierActive == "activet",
            collection: this.state.airCourierActive == "activet" ? "lmaircourierloadshare"
                : this.state.truckActive == "activet" ? "lmcourierloadshare"
                    : ""

        }
        var transData = []
        // kept locally too - createRows runs in the same tick, where this.state is still stale
        var zoneTotalsData = []
        var allTransporters = []
        if (this.state.airCourierActive != "activet" && this.state.truckActive != "activet") {
            await redirectURL.post("/lmconsignees/getActualSobPercentage", params).then((response) => {
                console.log(response.data.loadShareData, "loadShareData");
                console.log(response.data.zoneTotals, "zoneTotals");
                this.setState({
                    transdata: response.data.loadShareData,
                    zoneTotals: response.data.zoneTotals,
                })
                transData = response.data.loadShareData;
                zoneTotalsData = response.data.zoneTotals;
            }).catch((e) => {
                console.log(e);
            })
        } else {
            await redirectURL.post("/lmconsignees/getActualCourierSobPercentage", params).then((response) => {
                console.log(response.data.loadShareData, "loadShareData");
                console.log(response.data.zoneTotals, "zoneTotals");
                this.setState({
                    transdata: response.data.loadShareData,
                    zoneTotals: response.data.zoneTotals,
                })
                transData = response.data.loadShareData;
                zoneTotalsData = response.data.zoneTotals;
            }).catch((e) => {
                console.log(e);
            })
        }

        var transporters = await redirectURL.post('/lmconsignees/prtUniqueTransportersListWithNames', params)
            .then((response) => {
                //console.log(response.data);
                var transporters = response.data;
                var trnsportersList = [];
                if (transporters.length > 0) {
                    transporters.map((item) => {
                        trnsportersList.push(item.transporter_code)
                    })
                }
                this.setState({
                    trnsportersList: transporters,
                })
                return transporters;
            })
            .catch(function (error) {
                console.log(error)
            });

        var zones = await redirectURL.post("/lmconsignees/getLmSobZones", params).then((response) => {
            var zones = response.data;
            this.setState({
                zonesList: zones,
            })
            return zones;
        }).catch((e) => {
            console.log(e);
        })

        await redirectURL.post("/lmconsignees/getLmSobUniqueZones", params).then((response) => {
            var states = response.data;
            var statesList = [];
            if (states.length > 0) {
                states.map((item) => {
                    statesList.push(item)
                })
            }
            this.setState({
                statesList: statesList,
            })
        }).catch((e) => {
            console.log(e);
        })
        if (this.state.truckActive == "activet" || this.state.airCourierActive == "activet") {
            allTransporters = await redirectURL.post("/lmconsignees/getLmTransporters", params).then((response) => {
                // console.log(response.data);
                // this.setState({
                //     rowData: response.data
                // })
                return response.data
                // console.log(response.data.filter((each) => each.transporter_name == "BARODA FREIGHT CARRIERS"))
            }).catch((e) => {
                console.log(e);
            })
        }


        var columns = await this.createColumnDefs(zones);
        var { rowData, total } = await this.createRows(transporters, zones, transData, zoneTotalsData);
        this.setState({
            columnwithDefs: columns,
            rowData: rowData,
            total: total,
            loadshow: "show-n",
            overly: "show-n", allTransporters: allTransporters
        })

    }
    createColumns() {

        var transporters = this.state.trnsportersList;
        var states = this.state.statesList
        var columns = []
        columns.push({
            headerName: "Transporter Name",
            field: "transporter_name",
            width: 230,
            editable: false
        })
        columns.push({
            headerName: "Transporter Code",
            field: "transporter_code",
            width: 180,
            editable: false,
            cellStyle: { borderLeft: '1px solid #ccc' }
        })
        states.map((trans) => {
            var defs = {}
            transporters.map((ste) => {
                var ss = trans
                defs.headerName = trans;
                defs.field = ss;
                defs.width = 190;
                defs.editable = false;
                // defs.cellStyle = { borderLeft: '1px solid #ccc' };
                defs.cellRendererFramework = function (params) {

                    // var rendComponent = {
                    //     component: 'Showlmvalue'
                    // };
                    // return rendComponent
                    if (params.value === "View States") {
                        return (
                            <span
                                style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                            // onClick={() => handleViewCities(hArray, params.colDef.headerName)}
                            >
                                View States
                            </span>
                        );
                    }
                    return params.value;
                }
            })

            columns.push(defs)
        })
        console.log("Columns ", columns)
        this.setState({
            columnwithDefs: columns,
            overly: "show-n",
            loadshow: "show-n",
        })
    }
    createColumnDefs(hArray) {
        const uniqueZones = [...new Set(hArray.map(e => e.zone))];

        const columnDefs = [
            { headerName: "Transporter Name", field: "transporter_name", width: 250, pinned: "left" },
            { headerName: "Transporter Code", field: "transporter_code", width: 190, pinned: "left" },

            ...uniqueZones.map((zone) => ({
                headerName: `${zone} ( % )`,
                field: zone,
                width: 190,

                cellRendererFramework: (params) => {
                    if (params.value === "View States") {
                        
                        return (
                            <span
                                style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                                onClick={() => 
                                    // console.log(params)
                                    this.onCellClicked(params.colDef.field)
                                }
                            >
                                View States
                            </span>
                        );
                    }
                    return params.value || 0;
                }

            }))
        ];
        return columnDefs
    };
    createRows(transporters, hubCity, transdata, zoneTotals) {
        let rowdefs = [];
        const uniqueHubs = [...new Set(hubCity.map(e => e.zone))];
        // This grid reports a transporter's SHARE of its zone, not the load itself. The API sends
        // CMT per (zone, transporter) in `load` plus the zone's own total, so the share is worked
        // out here - printing `load` straight into the cell is what made columns read 246.63 and
        // the total row 393.59 instead of 100.
        const totals = zoneTotalMap(zoneTotals);
        transporters.forEach((ste) => {
            let rows = {
                transporter_name: ste.transporter_name,
                transporter_code: ste.transporter_code
            };

            // initialize all hubs with 0
            uniqueHubs.forEach((hub) => {
                rows[hub] = 0;
            });

            // fill actual data
            transdata.forEach((t) => {
                if (t.transporter_code === ste.transporter_code) {
                    rows[t.zone] = sharePercent(t.load, totals[String(t.zone).toUpperCase()]);
                }
            });

            rowdefs.push(rows);
        });

        // 🔹 Total Row - the shares of a zone add up to 100 (0 where the zone carried no load)
        let totalRow = {
            transporter_name: "",
            transporter_code: "Total ( % )"
        };

        uniqueHubs.forEach((hub) => {
            totalRow[hub] = 0;
        });

        rowdefs.forEach((row) => {
            uniqueHubs.forEach((hub) => {
                totalRow[hub] += parseFloat(row[hub]) || 0;
            });
        });
        uniqueHubs.forEach((hub) => {
            totalRow[hub] = Number(totalRow[hub].toFixed(2));
        });

        // 🔹 View Row
        let hubDetails = {
            transporter_name: "",
            transporter_code: ""
        };

        uniqueHubs.forEach((hub) => {
            hubDetails[hub] = "View States";
        });
        // setCalculatedData([...rowdefs])
        // setTotalRowData([hubDetails, totalRow])
        return { rowData: [...rowdefs], total: [hubDetails, totalRow] }
        // return {
        //     rowData: [...rowdefs, hubDetails],
        //     totalRow
        // };
    };
    createRows1() {
        var statesList = this.state.statesList;
        var transporters = this.state.trnsportersList;
        var transdata = this.state.transdata;
        var zoneTotals = this.state.zoneTotals;
        var rowdefs = []
        var totalCnt = 0

        transporters.map((ste) => {
            var rows = {}
            rows.transporter_name = ste.transporter_name;
            rows.transporter_code = ste.transporter_code;
            var rowcnt = 0
            if (transdata.length > 0) {
                var transportername = groupBy(transdata, rdata => rdata.transporter_code);
                transportername.forEach((trans, transkey) => {
                    trans.map((t) => {
                        rows["zone"] = transkey;
                        if (t.transporter_code == ste.transporter_code) {
                            var czoneTotals = zoneTotals.filter(function (e) { return e.zone == t.zone })
                            //console.log(czoneTotals,"czoneTotals")
                            var sharePer = 0;
                            if (czoneTotals.length > 0) {
                                var tLoad = t.load;
                                var loadTot = czoneTotals[0].totalLoad;
                                if (loadTot > 0) {
                                    var sharePer = (tLoad / loadTot) * 100;
                                }
                            }
                            if (Number.isInteger(sharePer) == false) {
                                rows[t.zone] = sharePer.toFixed(2);
                            }
                            else {
                                rows[t.zone] = sharePer;
                            }
                            rowcnt = rowcnt + parseFloat(t.load)
                        }
                    })

                })
            }
            var totalRowCnt = rowcnt;
            totalCnt = totalCnt + parseInt(rowcnt);
            if (Number.isInteger(totalRowCnt) == false) {
                var totalRowCnt = rowcnt.toFixed(2);
            }
            rowdefs.push(rows)
        })
        var zoneDetails = {};
        zoneDetails.transporter_name = "";
        zoneDetails.transporter_code = "";
        statesList.map(function (s) {
            zoneDetails[s] = "View States";
        });
        rowdefs.push(zoneDetails)
        console.log("rowdefs ", rowdefs)
        this.setState({
            rowData: rowdefs
        })
    }
    onGridReady = params => {
        this.gridApi = params.api;
        //console.log("Grid is: ", params);
        this.gridColumnApi = params.columnApi;
    };
    onGridState = () => {
        //console.log(this.gridApi);

        /*Get  Current Columns State and Store in this.colState */
        this.colState = this.gridColumnApi.getColumnState();

        /*Get Current RowGroup Columns State and Store in this.rowGroupState */
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

        /*Get Current Pivot Columns State and Store in this.pivotColumns, 
        * User should enable the Pivot mode.*/
        this.pivotColumns = this.gridColumnApi.getPivotColumns();

        /*Get Current Filter State and Store in window.filterState */
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);
    }



    closeAlert = () => {
        this.setState({
            show: false
        });
    }

    onCellClicked(e) {
        // if (e.value == "View States") {
        var zone = e;
        if (zone != undefined && zone != '') {
            var zonesList = this.state.zonesList;
            var zoneStates = zonesList.filter(function (e) { return e.zone == zone });
            // console.log(zonesList, "zonesList")
            // console.log(zoneStates, "zoneStates")
            // $(".subH").html(zone + " States");
            this.setState({
                sliderType: true,
                zoneStates: zoneStates,
                overly: "show-m",
                // bulkslide: "slider-translate"
            })
        }
        // }
    }

    onHeaderClicked(e) {
        console.log(e);
        var sortState = this.gridApi.getSortModel();
        console.log(sortState, "sortState")
    }

    onCellUpdateData = (params) => {
        console.log("Params ", params)
        var colData = params.data;
        var objects = Object.keys(colData);
        var rowTotal = 0;
        objects.map(function (e) {
            if (parseInt(params.data[e]).toString() != "NaN") {
                rowTotal = parseInt(rowTotal) + parseInt(params.data[e]);
            }
        })
        if (parseInt(rowTotal) > parseInt(100)) {
            this.setState({
                show: true,
                basicType: "warning",
                basicTitle: "Share Of Business Should not be greater than 100%"
            });
            var currentField = params.colDef.field;
            params.data[currentField] = 0
        }
    }

    onClickHideAll() {
        this.setState({
            loadshow: 'show-n',
            overly: 'show-n',
            zoneStates: [],
            sliderType: 1,
            bulkslide: "",
            fileName: "", errors: [], validData: []
        });

    }
    updateLmStates(params) {
        //console.log(params);
        if (params.transporter_name != '' && params.transporter_name != undefined && params.state != '' && params.state != undefined && params.sob != '' && params.sob != undefined) {
            params.data_type = this.state.data_type;
            redirectURL.post("/lmconsignees/savelmshareofbusiness", params).then((response) => {
                console.log(response);
                if (response.data.message == "Success") {
                    this.setState({
                        basicTitle: "Updated Successfully.",
                        basicType: "success",
                        show: true
                    })
                    window.location.reload();
                }
                else {
                    this.setState({
                        basicTitle: "Failed to update.",
                        basicType: "warning",
                        show: true
                    })
                }
            })
        }
        else {
            this.setState({
                basicTitle: "Fields Should not be Empty.",
                basicType: "warning",
                show: true
            })
        }
    }
    addNewRow() {
        // console.log(this.gridApi);
        this.gridApi.insertItemsAtIndex(0, [{ transporter_name: "", state: "", sob: "" }])
        // this.gridApi.updateRowData({add:[{holiday_date:"",holiday_name:""}]});
    }
    showGrid() {
        this.setState({
            showCalendar: "show-n",
            showGridData: "show-m"
        })
    }
    onClickDataExport() {
        var params = {
            fileName: "actual_sob_percentage.csv"
        };
        this.gridApi.exportDataAsCsv(params);
    }
    showBulkUpload() {
        $(".subH").html("Bulk Upload");
        this.setState({
            overly: "show-m",
            bulkslide: "slider-translate",
            errors: [],
            validData: [],
            fileName: ""
        })
    }
    resetUpload = () => {
        this.setState({
            bulkslide: '',
            zoneStates: [],
            sliderType: 1,
            overly: 'show-n',
            file: ''
        });
        document.getElementById("upform").reset();
    }
    changeFileHandler = async (e) => {
        var dt = '';
        const config = {
            headers: [
                {
                    name: 'id',
                    inputName: 'id',
                    required: false,
                },
                {
                    name: 'Transporter',
                    inputName: 'transporter_name',
                    required: true,
                    requiredError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
                {
                    name: 'State',
                    inputName: 'state',
                    required: false,
                    requiredError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
                {
                    name: 'Share Of Business',
                    inputName: 'sob',
                    required: false,
                    requiredError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
            ]
        }
        var data = CSVFileValidator(e.target.files[0], config)
            .then((csvData) => {
                this.setState({
                    csvData: csvData.data
                });
                console.log(csvData.data);
            })
            .catch(err => { })
        // console.log("e.target.files[0]",e.target.result);

        var out = new Promise(function (reject, resolve) {
            var reader = new FileReader();
            reader.onload = async function (e) {
                var contents = await e.target.result;
                resolve(contents);
            };
            var tt = reader.readAsText(e.target.files[0]);
        });
        this.checkFileData();
        this.setState({
            file: e.target.files[0]
        });
        // console.log("e.target.files[0].type ", e.target.files[0]);
        var check = verifyext(e.target.files[0].name);
        //console.log("Check ", check)
        if (check == true) {
            if (e.target.files[0].type == '' || e.target.files[0].type == 'text/csv' || e.target.files[0].type == 'application/vnd.ms-excel') {
                // console.log(fileData);
                // console.log(typeof(fileData))

            }
            else {
                e.target.value = null;
                this.setState({
                    uploadFile: '',
                    show: true,
                    basicType: 'danger',
                    basicTitle: 'Please upload file having extensions .csv only.',
                });
            }
        }
        else {
            e.target.value = null;
            this.setState({
                uploadFile: '',
                show: true,
                basicType: 'danger',
                basicTitle: 'Please upload file having extensions .csv only.',
            });
        }

    }

    checkFileData() {

        var vdata = verifycsvdata(JSON.stringify(this.state.csvData));
        //console.log("verifycsvdata ", vdata)
        if (vdata == 0) {
            this.setState({
                csvData: '',
                show: true,
                basicType: 'danger',
                basicTitle: 'File contains invalid data',
                uploadFile: '',
                file: ""
            });
        }
    }
    uploadBulkFormHandler(event) {
        event.preventDefault();
        var fileData = this.state.csvData;
        var flag = 0;
        console.log(fileData, "fileData");

        if (flag == 0) {
            if (fileData.length > 0) {
                var reqParams = {
                    csvData: fileData,
                    data_type: this.state.data_type
                }
                console.log("reqParams", reqParams)
                redirectURL.post("/lmconsignees/savebulklmshareofbusiness", reqParams).then((response) => {
                    var resp = response.data.message;
                    console.log(resp)
                    this.setState({
                        basicTitle: resp,
                        basicType: "success",
                        show: true,
                        bulkslide: '',
                        overly: 'show-n',
                    })
                    window.location.reload();
                }).catch((e) => {
                    console.log(e);
                })
            }
            else {
                this.setState({
                    basicTitle: "Invalid File",
                    basicType: "warning",
                    show: true,
                })
            }
            $('#upform')[0].reset();
        }
        else {
            $("#bulkUploadID").val();
            this.setState({
                basicTitle: "Fields Should not be Empty",
                basicType: "warning",
                show: true,
            })
            $('#upform')[0].reset();
        }
    };




    onSelectBulkPlants = (location) => {
        var plants = [];
        try {
            location.map(function (e) {
                plants.push(e.value);
            })
            console.log(plants);
            this.setState({
                plant_name: plants
            });
        }
        catch (e) {
            console.log(e);
        }

    }

    updateGridData() {
        var allrows = []
        this.gridApi.forEachNode((node, index) => {
            //console.log("node ",node)
            allrows.push(node.data)
        })
        //console.log("allrows ", allrows)
        var records = []
        if (allrows.length > 0) {
            allrows.forEach((item) => {
                //console.log("item ", item)
                var row = {}
                row.state = item.state
                //row.transporter_code = item.transporter_code

                var transporters = []
                for (var x in item) {
                    //console.log("Item key ", x)
                    if (x == "state" || x == "transporter_code") {
                    }
                    else {
                        transporters.push({
                            "transporter_code": x,
                            "sob": parseFloat(item[x])
                        })
                    }
                }
                row.transporters = transporters
                records.push(row)
            })
        }
        //console.log("records ",records)
        var loading_port_code = this.state.loading_port_code;
        var parameters = {
            records: records,
            loading_port_code: loading_port_code,
            data_type: this.state.data_type,
        }
        redirectURL.post("/lmconsignees/updatesharebusiness", parameters)
            .then((response) => {
                console.log(response);
                if (response.data.message == "success") {
                    this.setState({
                        basicTitle: "Updated Successfully.",
                        basicType: "success",
                        show: true
                    })
                    this.onLoadShowData()
                }
                else {
                    this.setState({
                        basicTitle: "Failed to update.",
                        basicType: "warning",
                        show: true
                    })
                }
            })
    }

    componentDidUpdate() {
        if (this.context && this.context.loading_port_code !== this._lastLoadingPortCode) {
            this._lastLoadingPortCode = this.context.loading_port_code;
            this.onGlobalPortChange(this.context.loading_port_code);
        }
    }
    onGlobalPortChange = async (selectedPlant) => {
        if (!selectedPlant) { return; }
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m',
        })
        await this.pageAccess();
    }
    async onClickTab(data_type, type) {
        var regularActive = "";
        var truckActive = "";
        var courierActive = "";
        var hubActive = "";
        var airCourierActive = "";
        if (data_type == 1 && type != "hub") {
            regularActive = "activet";
        }
        else if (data_type == 2 && type != "airCourier") {
            truckActive = "activet";
        } else if (data_type == 3) {
            courierActive = "activet";
        } else if (data_type == 1 && type == "hub") {
            hubActive = "activet";
        } else if (data_type == 2 && type == "airCourier") {
            airCourierActive = "activet";
        }

        await this.setState({
            data_type: data_type,
            regularActive: regularActive,
            truckActive: truckActive,
            courierActive: courierActive,
            hubActive: hubActive,
            airCourierActive: airCourierActive
        });
        if (type == "hub") {
            return;
        }
        await this.onLoadShowData();
    }
    getShortFileName = (name, maxLength = 31) => {
        const lastDot = name.lastIndexOf(".");
        const baseName = name.substring(0, lastDot);
        const extension = name.substring(lastDot);

        if (baseName.length <= maxLength) return name;

        return baseName.substring(0, maxLength) + "..." + extension;
    };
    isValidNumber = (value) => {
        const str = String(value || "").trim();
        return str !== "" && /^-?\d+(\.\d+)?$/.test(str);
    };

    handleFileChange = (e) => {

        const file = e.target.files[0];
        e.target.value = ""; // reset immediately

        if (!file) return;
        this.setState({ fileName: file.name })

        const reader = new FileReader();
        reader.readAsArrayBuffer(file);

        reader.onload = (event) => {

            const workbook = XLSX.read(
                new Uint8Array(event.target.result),
                { type: "array" }
            );

            const sheet = workbook.Sheets[workbook.SheetNames[0]];

            const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });

            this.validateExcelData(data);
        };
    };

    // ================= VALIDATION =================


    // validateExcelDataCopy = (data) => {

    //     let errorList = [];
    //     let cleanedData = [];

    //     // All transporters
    //     const allTransporters = this.state.allTransporters;

    //     // Store uploaded data
    //     let uploadedMap = {};

    //     // ---------------- VALIDATE EXCEL DATA ----------------

    //     data.forEach((row, index) => {

    //         const rowNumber = index + 2;


    //         let state = String(
    //             row["State"] || ""
    //         ).trim();

    //         let transporterName = String(
    //             row["Transporter Name"] || ""
    //         ).trim();

    //         let loadshare = String(
    //             row["Load Share"] || ""
    //         ).trim();

    //         let rowErrors = [];

    //         // Validate transporter
    //         if (!this.checkTransporterIdentity(transporterName)) {

    //             rowErrors.push(
    //                 `Transporter - "${transporterName}" does not exist.`
    //             );
    //         }

    //         // Validate state
    //         if (!this.checkStateIdentity(state)) {

    //             rowErrors.push(
    //                 `State - "${state}" does not exist.`
    //             );
    //         }


    //         // Validate loadshare
    //         if (!this.isValidNumber(loadshare)) {

    //             rowErrors.push(
    //                 `Load Share - "${loadshare}" must be numeric.`
    //             );
    //         }

    //         // Store errors
    //         if (rowErrors.length > 0) {

    //             errorList.push({

    //                 row: rowNumber,

    //                 errors: rowErrors
    //             });

    //         } else {

    //             // Store uploaded values
    //             // uploadedMap[`${zone}__${transporterName}`] = {

    //             //     load_share: Number(loadshare),

    //             //     state: state
    //             // };
    //             uploadedMap[
    //                 `${zone}__${state}__${transporterName}`
    //             ] = {
    //                 load_share: Number(loadshare)
    //             };
    //         }
    //     });

    //     // ---------------- EMPTY FILE ----------------

    //     if (data.length === 0) {

    //         errorList.push({

    //             row: "",

    //             errors: ["No Data found"]
    //         });
    //     }

    //     // ---------------- GENERATE ALL COMBINATIONS ----------------

    //     if (errorList.length === 0) {

    //         // Loop all zones
    //         allZones.forEach((stateObj) => {

    //             const state = stateObj.state_name;
    //             const zone = stateObj.zone;

    //             let totalLoadShare = 0;

    //             // total loadshare
    //             allTransporters.forEach((tr) => {

    //                 const key =
    //                     `${zone}__${state}__${tr.transporter_name}`;

    //                 const uploadedRow = uploadedMap[key];

    //                 totalLoadShare += uploadedRow
    //                     ? uploadedRow.load_share
    //                     : 0;
    //             });

    //             // create all combinations
    //             allTransporters.forEach((tr) => {

    //                 const key =
    //                     `${zone}__${state}__${tr.transporter_name}`;

    //                 const uploadedRow = uploadedMap[key];

    //                 const loadShareValue =
    //                     uploadedRow
    //                         ? uploadedRow.load_share
    //                         : 0;

    //                 const sob =
    //                     totalLoadShare > 0
    //                         ? Number(
    //                             (
    //                                 (loadShareValue / totalLoadShare) * 100
    //                             ).toFixed(2)
    //                         )
    //                         : 0;

    //                 cleanedData.push({

    //                     transporter_name:
    //                         tr.transporter_name,

    //                     transporter_code:
    //                         tr.transporter_code,

    //                     state: state,

    //                     zone: zone,

    //                     load_share: loadShareValue,

    //                     sob: sob
    //                 });
    //             });
    //         });
    //     }

    //     // ---------------- SET STATE ----------------

    //     this.setState({

    //         errors: errorList,

    //         validData: cleanedData
    //     });

    //     console.log("Errors:", errorList);

    //     console.log("Valid Data:", cleanedData);
    // };

    validateExcelData = (data) => {

        let errorList = [];

        let cleanedData = [];

        // All transporters
        const allTransporters =
            this.state.allTransporters || [];

        // Store uploaded rows
        let uploadedMap = {};

        // ---------------- VALIDATE EXCEL DATA ----------------

        data.forEach((row, index) => {

            const rowNumber = index + 2;

            let state = String(
                row["State"] || ""
            ).trim();

            // Transporter by CODE only - the name comes from the master (sobTransporterLookup).
            let transporterCode = normalizeTransporterCode(
                row["Transporter Code"]
            );

            let loadshare = String(
                row["Load Share"] || ""
            ).trim();

            let rowErrors = [];

            // Validate transporter
            if (
                !this.checkTransporterIdentity(
                    transporterCode
                )
            ) {

                rowErrors.push(
                    `Transporter Code - "${transporterCode}" is not in transporter master for this warehouse.`
                );
            }

            // Validate state
            if (
                !this.checkStateIdentity(state)
            ) {

                rowErrors.push(
                    `State - "${state}" does not exist.`
                );
            }

            // Validate loadshare
            if (
                !this.isValidNumber(loadshare)
            ) {

                rowErrors.push(
                    `Load Share - "${loadshare}" must be numeric.`
                );
            }

            // transporter + state mapping validation
            const transporterObj =
                allTransporters.find(
                    (tr) =>
                        tr.state === state &&
                        normalizeTransporterCode(tr.transporter_code) === transporterCode
                );

            if (!transporterObj) {

                rowErrors.push(
                    `Transporter Code - "${transporterCode}" not mapped for state - "${state}".`
                );
            }

            // Store errors
            if (rowErrors.length > 0) {

                errorList.push({

                    row: rowNumber,

                    errors: rowErrors
                });

            } else {

                const key =
                    `${state}__${transporterCode}`;

                uploadedMap[key] = {

                    transporter_name:
                        transporterObj.transporter_name,

                    transporter_code:
                        transporterObj.transporter_code,

                    state:
                        transporterObj.state,

                    zone:
                        transporterObj.zone,

                    load_share:
                        Number(loadshare)
                };
            }
        });

        // ---------------- EMPTY FILE ----------------

        if (data.length === 0) {

            errorList.push({

                row: "",

                errors: ["No Data found"]
            });
        }

        // ---------------- CREATE FINAL DATA ----------------

        if (errorList.length === 0) {

            // Add uploaded rows
            Object.keys(uploadedMap).forEach((key) => {

                const row = uploadedMap[key];

                cleanedData.push({

                    transporter_name:
                        row.transporter_name,

                    transporter_code:
                        row.transporter_code,

                    state:
                        row.state,

                    zone:
                        row.zone,

                    load_share:
                        row.load_share,

                    sob:
                        0
                });
            });

            // Add missing transporter-state rows
            allTransporters.forEach((tr) => {

                const key =
                    `${tr.state}__${normalizeTransporterCode(tr.transporter_code)}`;

                // if not uploaded
                if (!uploadedMap[key]) {

                    cleanedData.push({

                        transporter_name:
                            tr.transporter_name,

                        transporter_code:
                            tr.transporter_code,

                        state:
                            tr.state,

                        zone:
                            tr.zone,

                        load_share:
                            0,

                        sob:
                            0
                    });
                }
            });

            // ---------------- CALCULATE ZONE WISE SOB ----------------

            // zone totals
            let zoneTotals = {};

            cleanedData.forEach((row) => {

                if (!zoneTotals[row.zone]) {

                    zoneTotals[row.zone] = 0;
                }

                zoneTotals[row.zone] +=
                    Number(row.load_share || 0);
            });

            // calculate sob
            cleanedData = cleanedData.map((row) => {

                const total =
                    zoneTotals[row.zone] || 0;

                const sob =
                    total > 0
                        ? Number(
                            (
                                (
                                    Number(row.load_share) /
                                    total
                                ) * 100
                            ).toFixed(2)
                        )
                        : 0;

                return {

                    ...row,

                    sob: sob
                };
            });
        }

        // ---------------- SET STATE ----------------

        this.setState({

            errors: errorList,

            validData: cleanedData
        });

        console.log(
            "Errors:",
            errorList
        );

        console.log(
            "Valid Data:",
            cleanedData
        );
    };
    checkZoneIdentity = (name) => {
        return this.state.statesList.some(
            (each) => each === (name || "")
        );
    };


    checkTransporterIdentity = (transporterCode) => {
        return findTransporterByCode(this.state.trnsportersList, transporterCode) !== null;
    };


    checkStateIdentity = (state) => {
        return this.state.zonesList.some(
            (each) => (each.state === state)
        );
    };

    handleBulkUpload = async () => {

        try {
            this.setState({
                loadshow: "show-m",
                overly: "show-m"
            })

            const finalData = this.state.validData
            // console.log(this.state.validData, finalData)

            await this.bulkUpdateLoadshare(finalData)
            await this.onLoadShowData();
            this.setState({
                loadshow: "show-n",
                overly: "show-n",
                errors: [],
                validData: [],
                bulkslide: false,
                fileName: "",

            })
            if (this.fileInputRef.current) {
                this.fileInputRef.current.value = "";
            }


            // alert("Upload Successful");

        } catch (err) {
            console.error(err);
        }
    };

    bulkUpdateLoadshare = async (array) => {
        // console.log(object)
        var params = {
            data: array,
            comp_code: this.state.comp_code,
            loading_port_code: this.state.loading_port_code,
            user_name: localStorage.getItem('username'),
            email: localStorage.getItem('email'),
            user_department: localStorage.getItem('lm_department'),
            staff_id: localStorage.getItem('staff_id'),
            designation: localStorage.getItem('designation'),
            user_role: localStorage.getItem('roles'),
            name: this.state.airCourierActive == "activet" ? "Air Courier"
                : this.state.truckActive == "activet" ? "Surface Courier"
                    : "",
            collection: this.state.airCourierActive == "activet" ? "lmaircourierloadshare"
                : this.state.truckActive == "activet" ? "lmcourierloadshare"
                    : "",
            dat_type: this.state.data_type
        }
        try {

            const response = await redirectURL.post("/lmconsignees/updateCourierLoadShareData", params);
            if (response.data.status == "success") {
                // setRowData(response.data.hubData || [])
                this.setState({
                    basicTitle: "Updated Successfully.",
                    basicType: "success",
                    show: true
                })
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    render() {

        var columnwithDefs = [
            {
                headerName: "Transporter",
                field: "transporter_name",
                width: 150,
                filter: true,
                resizable: true,
                editable: true,
                cellEditor: 'agSelectCellEditor',
                cellEditorParams: {
                    values: this.state.trnsportersList,
                },
            },

            {
                headerName: "State",
                field: "state",
                width: 290,
                filter: true,
                resizable: true,
                editable: true,
                cellEditor: 'agSelectCellEditor',
                cellEditorParams: {
                    values: this.state.statesList,
                },
            },
            {
                headerName: "Share Of Business",
                field: "sob",
                width: 100,
                filter: true,
                resizable: true,
                editable: true,
            },
            {
                pinned: "left",
                headerName: "Update",
                field: "_id",
                width: 150,
                resizable: true,
                editable: false,
                cellRendererSelector: function (params) {
                    var rendComponent = {
                        component: 'UpdateButton'
                    };
                    return rendComponent;
                },
            },
            {
                pinned: "left",
                headerName: "id",
                field: "id",
                width: 100,
                filter: true,
                resizable: true,
                editable: false,
            },
        ]
        var errTrueUpload = this.state.errors.length > 0 && this.state.validData.length > 0
        var disableUpload = this.state.validData.length == 0
        var userroles = localStorage.getItem("roles")
        var isImportActive = this.state.truckActive === "activet" || this.state.airCourierActive === "activet"
        return (
            <div class="container-fluid d-flex flex-column" style={{ height: "100%" }}>
                <div style={{ zIndex: "100001" }}>
                    <SweetAlert
                        show={this.state.show}
                        type={this.state.basicType}
                        title={this.state.basicTitle}
                        onConfirm={this.closeAlert}
                    >
                    </SweetAlert>
                </div>

                <div className="row" style={{ marginBottom: "10px", flexShrink: 0 }}>
                    <div className="col-sm-12">
                        <ul
                            style={{
                                display: "inline-flex",
                                flexWrap: "wrap",
                                padding: "4px",
                                margin: 0,
                                listStyle: "none",
                                gap: "4px",
                                backgroundColor: "#ffffff",
                                borderRadius: "10px",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.15)"
                            }}
                        >
                            {[
                                { onClick: this.onClickTab.bind(this, 1, "hub"), label: "Hub", active: this.state.hubActive },
                                { onClick: this.onClickTab.bind(this, 1, ""), label: "Regular", active: this.state.regularActive },
                                { onClick: this.onClickTab.bind(this, 2, ""), label: "Surface Courier", active: this.state.truckActive },
                                { onClick: this.onClickTab.bind(this, 2, "airCourier"), label: "Air Courier", active: this.state.airCourierActive },
                                { onClick: this.onClickTab.bind(this, 3, ""), label: "Dedicated", active: this.state.courierActive },
                            ].map(({ onClick, label, active }, idx) => {
                                var isActive = active == "activet";
                                return (
                                    <li key={idx} onClick={onClick} style={{ listStyle: "none" }}>
                                        <button
                                            type="button"
                                            style={{
                                                whiteSpace: "nowrap",
                                                border: "none",
                                                outline: "none",
                                                borderRadius: "999px",
                                                padding: "8px 18px",
                                                fontSize: "13px",
                                                fontWeight: isActive ? 600 : 500,
                                                cursor: "pointer",
                                                transition: "all 0.2s ease",
                                                backgroundColor: isActive ? "#1976d2" : "transparent",
                                                color: isActive ? "#fff" : "#555",
                                                boxShadow: isActive ? "0 1px 4px rgba(25,118,210,0.4)" : "none"
                                            }}
                                        >
                                            {label}
                                        </button>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>

                {this.state.hubActive == "activet" ?
                    <HubSOBPage />
                    // : this.state.airCourierActive == "activet" ?
                    // <AirCourierPage /> 
                    :
                    <>
                        <div className="card col-xl-12" style={{ borderRadius: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)", flex: "1 1 0%", display: "flex", flexDirection: "column", minHeight: 0 }}>
                            {/* HEADER */}
                            <div className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap", gap: "10px", padding: "14px 18px", flexShrink: 0 }}>
                                <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                                    <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                                    <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px" }}>Actual SOB Percentage</h5>
                                </div>
                                <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "8px" }}>
                                    {(this.state.pageAccess != 2 && isImportActive) ?
                                        <button className="pill-btn pill-btn-info" onClick={this.showBulkUpload.bind(this)}>Import Data</button>
                                        : ""}
                                    {/* The setup BEHIND these numbers: which MSIL transporter child codes are
                                        credited to which warehouse. A pop-up on this screen, not a menu entry of
                                        its own (client, 2026-10-14) - and a LABELLED button, because a bare gear
                                        blended into the header and read as decoration. */}
                                    <button type="button" className="pill-btn pill-btn-info"
                                            title="Which MSIL transporter child codes are credited to which warehouse"
                                            onClick={() => this.setState({ sobConfigOpen: true })}>
                                        <i className="icofont icofont-gear" style={{ marginRight: "6px" }}></i>
                                        Configuration
                                    </button>
                                </div>
                            </div>
                            {/* {(this.state.lpNames.length > 0) ?
                                <div className="row col-xl-12 col-lg-12" style={{ marginTop: "2%" }}>
                                    <div className="col-xl-12 col-lg-12">
                                        {this.state.lpNames.length == 1 ?
                                            <span style={{ fontSize: "16px" }}>Loading Plant : {(this.state.lpNames[0].loading_port)}</span>
                                            :
                                            <span style={{ fontSize: "16px" }}>Loading Plant :
                                                <select id="loadingPlant" onChange={this.onChangeLoadingPlant.bind(this)}>
                                                    {(this.state.lpNames).map(function (obj) {
                                                        return <option value={obj.loading_port_code}>{obj.loading_port}</option>
                                                    })}
                                                </select>
                                            </span>
                                        }
                                    </div>
                                </div>
                                : ""} */}
                            <div className="col-xl-12 col-lg-12" style={{ flex: 1, width: "100%", display: "flex", flexDirection: "column", minHeight: 0, padding: "0 15px" }}>
                                {/* <div id="myGrid" style={{ width: "100%", height: "500px" }} className={"ag-theme-balham d-none" + this.state.showGridData}>
                                    <AgGridReact
                                        modules={this.state.modules}
                                        columnDefs={this.state.columnwithDefs}
                                        defaultColDef={this.state.defaultColDef}
                                        rowData={this.state.rowData}
                                        enableCharts={false}
                                        // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                        onGridReady={this.onGridReady}
                                        onGridState={this.onGridState}
                                        frameworkComponents={this.state.frameworkComponents}
                                        statusBar={this.state.statusBar}
                                        sideBar={this.state.sideBar}
                                        stopEditingWhenGridLosesFocus={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        pagination={false}
                                        gridOptions={{
                                            context: { componentParent: this }
                                        }}
                                        // components={this.state.components}
                                        enableRangeSelection={true}
                                        sortChanged={this.onHeaderClicked.bind(this)}
                                        onCellClicked={this.onCellClicked.bind(this)}
                                    //onCellEditingStopped={this.onCellUpdateData.bind(this)}
                                    />
                                </div> */}
                                <div className="ag-theme-balham grid-wrapper mt-2 mb-3" style={{ flex: 1, minHeight: 0 }}>
                                    <AgGridReact
                                        // ref={this.gridRef}
                                        modules={this.state.modules}
                                        rowData={this.state.rowData}
                                        columnDefs={this.state.columnwithDefs}
                                        defaultColDef={{
                                            sortable: true,
                                            filter: true,
                                            floatingFilter: true
                                        }}

                                        statusBar={{
                                            statusPanels: [
                                                { statusPanel: "agSelectedRowCountComponent", align: "left" },
                                                { statusPanel: "agFilteredRowCountComponent", align: "center" },
                                                { statusPanel: "agTotalRowCountComponent", align: "right" }
                                            ]
                                        }}
                                        sideBar={{
                                            toolPanels: [
                                                {
                                                    id: 'columns',
                                                    labelDefault: 'Columns',
                                                    iconKey: 'columns',
                                                    toolPanel: 'agColumnsToolPanel'
                                                },
                                                {
                                                    id: 'filters',
                                                    labelDefault: 'Filters',
                                                    iconKey: 'filter',
                                                    toolPanel: 'agFiltersToolPanel'
                                                }
                                            ],
                                            // defaultToolPanel: 'filters'
                                        }}
                                        animateRows rowSelection={"multiple"}
                                        rowHeight={45}
                                        headerHeight={45}
                                        frameworkComponents={this.state.frameworkComponents}
                                        onSelectionChanged={() => {
                                            // if (this.gridRef && this.gridRef.current && this.gridRef.current.api) {
                                            //     const selected = this.gridRef.current.api.getSelectedRows();
                                            //     this.setState({ selectedRows: selected })
                                            // }
                                        }} 
                                        suppressRowClickSelection={true}
                                        pinnedBottomRowData={this.state.total || []}
                                    />
                                </div>
                                {/* <div style={{ float: "right", marginTop: "1%" }}>
                                    <button type="button" onClick={this.updateGridData.bind(this)} className="btn btn-warning">Assign</button>
                                </div> */}
                            </div>
                        </div>


                        {/* <button className="btn btn-success" onClick={this.formAssignHandler.bind(this)} style={{marginLeft:"91em"}}>Insert Exports</button> */}
                        <div className={"slide-r " + (this.state.bulkslide)} style={{ overflow: "hidden" }}>
                            <h3 className="subH">Bulk Upload</h3>
                            <div className="slide-r-body" style={{ position: "relative" }}>

                                <div className="container-fluid">
                                    {(this.state.sliderType == 2) ?
                                        <div className="row">
                                            <table className="table">
                                                <tbody>
                                                    {this.state.zoneStates.map(function (zs) {
                                                        return <tr>
                                                            <td style={{ padding: "5px", border: "none" }}>{zs.state}</td>
                                                        </tr>
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                        :
                                        <div className="row">
                                            <form method="POST" id="upform" className="theme-form" onSubmit={this.uploadBulkFormHandler}>

                                                <div className="form-group mt-20p">
                                                    <label className="">Upload File</label>
                                                    <input type="file" name="uploadFile" id="bulkUploadID" onChange={this.changeFileHandler} className="form-control" required />
                                                </div>
                                                <div className="form-group">
                                                    <button type="submit" className="pill-btn pill-btn-success">Submit</button>
                                                    <button type="button" onClick={this.resetUpload.bind(this)} className="pill-btn ml-2" style={{ backgroundColor: "#eceff1", color: "#455a64" }}>Cancel</button>
                                                </div>
                                            </form>
                                            <div className="form-group">
                                                <a className="pill-btn pill-btn-primary" href={require('../../assets/json/sample_share_of_business.csv')} target="_blank">Sample Template</a>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className={"dataLoadpage " + (this.state.loadshow)}>
                        </div>
                        <div className={"dataLoadpageimg " + (this.state.loadshow)}>
                            <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                        </div>
                        <div className={"overlay-part " + (this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
                    </>
                }
                {/* Actual SOB configuration - opened by the gear in the header above. It takes this
                    screen's own page access, so a view-only user can read the setup but not edit it. */}
                <ActualSobConfigPanel open={this.state.sobConfigOpen}
                                      loadingPortCode={this.state.loading_port_code}
                                      readOnly={this.state.pageAccess == 2}
                                      onClose={() => this.setState({ sobConfigOpen: false })} />
                {/* RIGHT SLIDER */}
                <div className={`hub-slider ${this.state.sliderType === true ? "open" : ""} d-flex flex-column`}>

                    <div className="slider-header">
                        {`${(this.state.zoneStates[0] || {}).zone} States`}
                        {/* <span onClick={closeSlider}>✕</span> */}
                    </div>

                    <div className="slider-body flex-grow-1 pt-4">
                        {this.state.zoneStates.slice(1,).map((each) => {
                            return <p className="font-bold" style={{ color: "#000", fontWeight: "bold" }}>{each.state}</p>
                        })}

                    </div>
                    <div className="slider-footer d-none">
                        <button
                            className="save-btn" style={{ margin: "0px" }}
                            onClick={""}
                        >
                            {/* {editIndex !== null ? "Update" : "Save"} */}
                        </button>
                    </div>
                </div>
                <div className={`hub-slider ${this.state.bulkslide ? "open" : ""} d-flex flex-column`}>

                    <div className="slider-header">
                        Import Data
                        <span onClick={this.onClickHideAll.bind(this)} style={{ cursor: "pointer" }}>✕</span>
                    </div>


                    <div className="slider-body flex-grow-1 d-flex flex-column" style={{ minHeight: "0px" }}>
                        <div
                            style={{
                                background: "#fff3cd",
                                border: "1px solid #ffeeba",
                                color: "#856404",
                                padding: "12px 16px",
                                borderRadius: "6px",
                                marginBottom: "12px",
                                fontSize: "14px",
                                fontWeight: 500
                            }}
                        >
                            Please ensure <b>Load Share Values</b> are provided for all{" "}
                            <b>Transporters</b>. Any missing values will be{" "}
                            <b>Automatically Considered as 0</b>.
                        </div>

                        <input
                            ref={this.fileInputRef}
                            type="file"
                            accept=".xlsx,.xls,.csv"
                            onChange={this.handleFileChange}
                            style={{ display: "none" }}
                        />
                        {/* Upload button */}
                        <div className="d-flex align-items-center gap-3">
                            <button
                                className="btn btn-info d-flex justify-content-center p-3"
                                type="button"
                                onClick={() => this.fileInputRef.current.click()}
                            >
                                Upload File
                            </button>

                            <a href={
                                require("../../assets/actual_sob.xlsx")
                            } className="btn btn-secondary d-flex justify-content-center ml-3 p-3 flex-grow-1">
                                Download Sample Template
                            </a>
                        </div>

                        {this.state.fileName && (
                            <div style={{ marginTop: "15px", display: "flex", gap: "6px", maxWidth: "410px" }}>
                                <span>Selected File :</span>
                                <span
                                    style={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        flex: 1,
                                        fontWeight: "bold"
                                    }}
                                    title={this.state.fileName}
                                >
                                    {this.getShortFileName(this.state.fileName)}
                                </span>
                            </div>
                        )}


                        {this.state.errors.length > 0 && (
                            <>
                                <h6 className="text-danger mt-3">Validation Errors</h6>

                                <div style={{ flexGrow: 1, overflowY: "auto", width: "100%" }}>
                                    <table className="table-bordered mb-0 err-table" style={{ width: "100%", positive: "relative" }}>
                                        <thead className="table-light text-center" style={{ positive: "sticky", zIndex: "100", backgroundColor: "#efefef" }}>
                                            <tr>
                                                <th style={{ width: "60px", padding: "9px 15px" }}>Row</th>
                                                <th>Error Description</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {this.state.errors.map((err, i) => (
                                                <tr key={i}>
                                                    <td className="text-center" style={{ padding: "9px 15px" }}>
                                                        {err.row}
                                                    </td>

                                                    <td style={{ padding: "9px 15px", wordBreak: "break-word" }}>
                                                        {err.errors.map((e, idx) => (
                                                            <p className="m-0" key={idx}>{e}</p>
                                                        ))}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}

                    </div>
                    <div className="slider-footer">
                        <button
                            className="save-btn" style={{ margin: "0px", width: "auto", padding: "5px 25px", cursor: disableUpload && "not-allowed", opacity: disableUpload && "0.5" }}
                            onClick={this.handleBulkUpload}
                            disabled={disableUpload}
                        >
                            {errTrueUpload ? "Submit only valid data" : "Submit"}
                        </button>
                    </div>

                </div>
            </div>

        );
    }
}

function dateComparator1(date1, date2) {
    //console.log(date1,date2);
    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
        // console.log(date1,date2);
        var date_1 = getMonthNumber(date1.split("-")[1]);
        date1 = date1.replace(date1.split("-")[1], date_1);
        var date_2 = getMonthNumber(date2.split("-")[1]);
        date2 = date2.replace(date2.split("-")[1], date_2);
        var date1Number = monthToComparableNumber1(date1);
        var date2Number = monthToComparableNumber1(date2);
        if (date1Number === null && date2Number === null) {
            return 0;
        }
        if (date1Number === null) {
            return -1;
        }
        if (date2Number === null) {
            return 1;
        }
        return date1Number - date2Number;
    }
}

function monthToComparableNumber1(date) {
    console.log(date.length);
    console.log(date);
    if (date === undefined || date === null || date.length !== 10) {
        return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
}
function dateComparator(date1, date2) {
    // console.log("dateComparator");
    // console.log(date1.length);
    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
        // console.log(date1,date2);
        var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
        date1 = date1.replace(date1.split(" ")[0].split("-")[1], date_1);
        var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
        date2 = date2.replace(date2.split(" ")[0].split("-")[1], date_2);
        // console.log(date1,date2);
        var date1Number = monthToComparableNumber(date1);
        var date2Number = monthToComparableNumber(date2);
        // console.log(date1Number,date2Number);
        if (date1Number === null && date2Number === null) {
            return 0;
        }
        if (date1Number === null) {
            return -1;
        }
        if (date2Number === null) {
            return 1;
        }
        return date1Number - date2Number;
    }
}
function monthToComparableNumber(date) {
    // console.log(date,date.length);
    if (date === undefined || date === null || date.length !== 16) {
        return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    console.log(yearNumber, monthNumber, dayNumber);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
}

function getMonthNumber(monthName) {
    var months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May',
        'Jun', 'Jul', 'Aug', 'Sep',
        'Oct', 'Nov', 'Dec'
    ];
    var monthNum = months.indexOf(monthName) + 1;
    if (monthNum < 10) {
        monthNum = "0" + monthNum.toString();
    }
    return monthNum;
}


function loadDateTimeScript() {
    // alert("timeDate");
    $('.datetimepicker_mask').datetimepicker({
        //mask:'39-19-9999 29:59',
        format: 'd-m-Y'
    });
    $('.datetimepicker_date').datetimepicker({
        mask: '39-19-9999',
        format: 'd-m-Y',
        timepicker: false
    });
    var index = window.document.getElementsByTagName("script")[1]
    var script = window.document.createElement("script")
    script.src = "https://www.jqueryscript.net/demo/Clean-jQuery-Date-Time-Picker-Plugin-datetimepicker/jquery.datetimepicker.js"
    //script.src="http://xdsoft.net/jqplugins/datetimepicker/"
    script.async = true
    script.defer = true
    index.parentNode.insertBefore(script, index)
}

function DateEditor() { }

// gets called once before the renderer is used
DateEditor.prototype.init = function (params) {
    // create the cell
    this.eInput = document.createElement('input');
    this.eInput.value = params.value;

    // https://jqueryui.com/datepicker/
    $(this.eInput).datetimepicker({
        dateFormat: "yy-mm-dd",
        changeMonth: true,
        changeYear: true,
        timepicker: false,
    });
};

// gets called once when grid ready to insert the element
DateEditor.prototype.getGui = function () {
    return this.eInput;
};

// focus and select can be done after the gui is attached
DateEditor.prototype.afterGuiAttached = function () {
    this.eInput.focus();
    this.eInput.select();
};

// returns the new value after editing
DateEditor.prototype.getValue = function () {
    // console.log(this.eInput.value);
    return this.eInput.value;
};

// any cleanup we need to be done here
DateEditor.prototype.destroy = function () {
    // but this example is simple, no cleanup, we could
    // even leave this method out as it's optional
};

// if true, then this editor will appear in a popup
DateEditor.prototype.isPopup = function () {
    // and we could leave this method out also, false is the default
    return false;
};
function groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}

const HubSOBPage = () => {
    // const location = useLocation();
    const gridRef = useRef();
    const portContext = useContext(LoadingPortContext);
    const lastPortRef = useRef(portContext.loading_port_code);

    const modules = [
        ClientSideRowModelModule,
        RowGroupingModule,
        MenuModule
    ];

    // ---------------- SLIDER STATE ----------------
    const [showSlider, setShowSlider] = useState(false);

    // ---------------- DROPDOWN ----------------
    const loadingPorts = [
        { value: "CHN", label: "Chennai" },
        { value: "MUM", label: "Mumbai" },
        { value: "KOL", label: "Kolkata" }
    ];

    // ---------------- FORM ----------------
    const [formData, setFormData] = useState({
        loading_port_code: null,
        hub_name: "",
        latitude: "",
        longitude: ""
    });

    const [rowData, setRowData] = useState(
    );
    const [editIndex, setEditIndex] = useState(null);
    const [loadingPortData, setLoadingPortData] = useState([])
    const [showBulkSlider, setShowBulkSlider] = useState(false);
    const [bulkFile, setBulkFile] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    console.log(loadingPortData, editIndex)

    const [loadshow, setLoadshow] = useState("show-n")
    const [overly, setOverly] = useState("show-n")
    const [pageAccess, setPageAccess] = useState(0);
    const [loadingPortCode, setLoadingPortCode] = useState("");
    const [compCode, setCompCode] = useState("");
    const [lpNames, setLpNames] = useState([]);
    const [errors, setErrors] = useState([]);
    const [validData, setValidData] = useState([]);
    const [fileName, setFileName] = useState("");
    const [transporterData, setTransporterData] = useState([]);
    const [hubCityData, setHubCityData] = useState([]);
    const [columnDefs, setColumnDefs] = useState([]);
    const [timeData, setTimeData] = useState({ from_date: moment.parseZone().format("YYYY-MM-DD") });
    const [controller, setController] = useState({ open: false });
    const [hubSOBData, setHubSOBData] = useState([]);
    const [calculatedData, setCalculatedData] = useState([]);

    const [totalRowData, setTotalRowData] = useState([]);
    const [cityList, setCityList] = useState([])
    const fileInputRef = useRef(null);

    const [overErrors, setOverErrors] = useState([])

    const closeSlider = () => {
        setShowSlider(false);
        setEditIndex(null);
        setFormData({
            loading_port_code: null,
            hub_name: "",
            latitude: "",
            longitude: ""
        });
    };

    // ---------------- GRID ----------------
    const components = {
        // actionRenderer: ActionRenderer
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoadshow("show-m")
            setOverly("show-m")
            var code = await pageAccessFn();
            // await getLoadingPortCodeData();
            var transporter = await getTransportersData(code);
            var hubCity = await getHubCityData(code);
            var sobData = await getHubSOBData(code);
            createColumnDefs(transporter, hubCity);
            createRows(transporter, hubCity, (sobData && sobData.loadShareData) || [],
                       (sobData && sobData.zoneTotals) || []);
            setLoadshow("show-n")
            setOverly("show-n")
        }
        fetchData();
    }, []);




    const pageAccessFn = async () => {

        setLoadshow("show-m");
        setOverly("show-m");

        const currentUrl = window.location.pathname;
        var resolved = await resolvePageAccess(currentUrl, portContext);
        if (!resolved) {
            setLoadshow("show-n");
            setOverly("show-n");
            return;
        }
        setPageAccess(resolved.pageAccess);
        setLoadingPortCode(resolved.loading_port_code);
        setCompCode(resolved.comp_code);
        setLoadingPortData(resolved.lpNames);
        return resolved.loading_port_code;
    };
    const getHubSOBData = async (port) => {
        try {
            var params = {
                loading_port_code: port || loadingPortCode,
                data_type: 1
            }
            const response = await redirectURL.post("/lmconsignees/getActualHubSobPercentage", params);
            console.log(response)
            if (response.status == "200") {
                setHubSOBData(response.data.loadShareData || [])
                // the hub totals travel with the rows - createRows needs both to work out the share
                return { loadShareData: response.data.loadShareData || [],
                         zoneTotals: response.data.zoneTotals || [] }
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const getTransportersData = async (port) => {
        try {
            var params = {
                loading_port_code: port || loadingPortCode,
                data_type: 1, hub_transporter: 1,
                status: 1
            }
            const response = await redirectURL.post("/lmconsignees/prtUniqueTransportersListWithNames", params);
            if (response.status == "200") {
                setTransporterData(response.data.filter((each) => each.transporter_code) || [])
                return response.data.filter((each) => each.transporter_code)
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const getHubCityData = async (port) => {
        try {
            var params = {
                loading_port_code: port || loadingPortCode,
                is_active: 1
            }
            const response = await redirectURL.post("/masters/getHubConsigneeCity", params);
            if (response.data.status == "success") {
                setHubCityData(response.data.hubMappingData || [])
                return response.data.hubMappingData || []
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const getLoadingPortCodeData = async () => {
        try {
            var params = {

            }
            const response = await redirectURL.post("/lmconsignees/getLmLoadingPorts", params);
            // console.log(response)
            if (response.status == "200") {
                // console.log(response)
                setLoadingPortData(
                    response.data
                        ? response.data.map((each) => ({
                            ...each,
                            label: each.comp_short_name,
                            value: each.loading_port_code
                        }))
                        : []
                );
                setLoadingPortCode(response.data[0].loading_port_code || "")
                return response.data[0].loading_port_code
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const createColumnDefs = (tArray, hArray) => {
        const uniqueHubs = [...new Set(hArray.map(e => e.hub_name))];

        const columnDefs = [
            { headerName: "Transporter Name", field: "transporter_name", width: 250 },
            { headerName: "Transporter Code", field: "transporter_code", width: 190 },

            ...uniqueHubs.map((hub) => ({
                headerName: `${hub} ( % )`,
                field: hub,
                width: 190,
                cellRendererFramework: (params) => {
                    if (params.value === "View Cities") {
                        return (
                            <span
                                style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                                onClick={() => handleViewCities(hArray, params.colDef.field)}
                            >
                                View Cities
                            </span>
                        );
                    }
                    return params.value;
                }

            }))
        ];
        setColumnDefs(columnDefs);
    };
    const createRows = (transporters, hubCity, transdata, zoneTotals) => {
        let rowdefs = [];
        const uniqueHubs = [...new Set(hubCity.map(e => e.hub_name))];
        // Same contract as the zone grid: getActualHubSobPercentage returns the hub's CMT in
        // `load` plus the hub totals, and this grid shows each transporter's share of it.
        // (It used to read `t.sob`, a field the API does not send, so every cell read 0.)
        const totals = zoneTotalMap(zoneTotals);
        transporters.forEach((ste) => {
            let rows = {
                transporter_name: ste.transporter_name,
                transporter_code: ste.transporter_code
            };

            // initialize all hubs with 0
            uniqueHubs.forEach((hub) => {
                rows[hub] = 0;
            });

            // fill actual data
            transdata.forEach((t) => {
                if (t.transporter_code === ste.transporter_code) {
                    rows[t.zone] = sharePercent(t.load, totals[String(t.zone).toUpperCase()]);
                }
            });

            rowdefs.push(rows);
        });

        // 🔹 Total Row - shares of a hub add up to 100 (0 where the hub carried no load)
        let totalRow = {
            transporter_name: "",
            transporter_code: "Total ( % )"
        };

        uniqueHubs.forEach((hub) => {
            totalRow[hub] = 0;
        });

        rowdefs.forEach((row) => {
            uniqueHubs.forEach((hub) => {
                totalRow[hub] += parseFloat(row[hub]) || 0;
            });
        });
        uniqueHubs.forEach((hub) => {
            totalRow[hub] = Number(totalRow[hub].toFixed(2));
        });

        // 🔹 View Row
        let hubDetails = {
            transporter_name: "",
            transporter_code: ""
        };

        uniqueHubs.forEach((hub) => {
            hubDetails[hub] = "View Cities";
        });
        setCalculatedData([...rowdefs])
        setTotalRowData([hubDetails, totalRow])
        // return {
        //     rowData: [...rowdefs, hubDetails],
        //     totalRow
        // };
    };
    const handleViewCities = (hArray, hub) => {
        setCityList([hub, ... new Set(hArray.filter((each) => each.hub_name == hub).map((each) => each.consignee_city))]);
        setShowSlider(true);
    }
    const updateHubSOBData = async (data) => {
        try {
            var params = {
                loading_port_code: loadingPortCode,
                data_type: 1, is_hub: 1,
                data: data
            }
            console.log(params)
            const response = await redirectURL.post("/lmconsignees/saveBulkLmHubLoadShare", params);
            if (response.data.status == "success") {
                // setRowData(response.data.hubData || [])
            } else {

            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleBulkUpload = async () => {

        try {
            setLoadshow("show-m")
            setOverly("show-m")
            const finalData = validData
            // .map((each) => {
            //     return (
            //         {
            //             ...each,
            //             loading_port_code: loadingPortCode,
            //             comp_short_name: loadingPortData.find((each) => each.value == loadingPortCode).label || "",
            //             is_active: 1
            //         }
            //     )
            // })
            console.log(validData, finalData)

            await updateHubSOBData(finalData)
            await getHubSOBData();
            setLoadshow("show-n")
            setOverly("show-n")
            setValidData([])
            setTimeData((prevState) => ({ ...prevState, valid_from: "", valid_to: "" }))
            setFileName("")
            setErrors([])
            setOverErrors([])
            setShowBulkSlider(false);
            setBulkFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }


            // alert("Upload Successful");

        } catch (err) {
            console.error(err);
        }
    };

    const onClickHideAll = () => {
        // setLoadshow("show-n")
        // setOverly("show-n")

    }

    const customStyles = {
        control: (provided) => ({
            ...provided,
            cursor: editIndex !== null ? "not-allowed" : "pointer"
        }),
        valueContainer: (provided) => ({
            ...provided,
            cursor: editIndex !== null ? "not-allowed" : "pointer"
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            cursor: editIndex !== null ? "not-allowed" : "pointer"
        }),
        container: (provided) => ({
            ...provided,
            cursor: editIndex !== null ? "not-allowed" : "pointer",
            width: "100%"
        })
    }

    const handleFileChange = (e) => {

        const file = e.target.files[0];
        e.target.value = ""; // reset immediately

        if (!file) return;
        setFileName(file.name); // store file name

        const reader = new FileReader();
        reader.readAsArrayBuffer(file);

        reader.onload = (event) => {

            const workbook = XLSX.read(
                new Uint8Array(event.target.result),
                { type: "array" }
            );

            const sheet = workbook.Sheets[workbook.SheetNames[0]];

            const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });

            validateExcelData(data);
        };
    };


    const validateExcelData = (data) => {

        let validationErrors = [];
        let overPercentErrors = [];
        let cleanedData = [];

        let hubMap = {};

        data.forEach((row, index) => {

            const rowNumber = index + 2;

            let hubName = String(row["Hub"] || "").trim().toUpperCase();
            let transporterCode = row["Transporter Code"];
            // Hub ACTUAL load (CMT) - this page shows / feeds actual SOB, not the approved share.
            let approvedSOB = row["Load"] !== undefined && row["Load"] !== "" ? row["Load"]
                : (row["Load (CMT)"] !== undefined ? row["Load (CMT)"] : row["Load Share"]);

            let rowErrors = [];

            // ---- Transporter (by CODE only - the name comes from the master) ----
            const masterTransporter = findTransporterByCode(transporterData, transporterCode);
            if (!masterTransporter) {
                rowErrors.push(
                    `Transporter Code - "${transporterCode}" is not in transporter master for this warehouse`
                );
            }

            // ---- Hub ----
            if (!checkHubIdentity(hubName)) {
                rowErrors.push(`Hub - "${hubName}" does not exist in Hub Master`);
            }

            // ---- Load ----
            if (!isValidNumber(approvedSOB) || parseFloat(approvedSOB) < 0) {
                rowErrors.push(
                    `Load should be numeric and >= 0 (${approvedSOB})`
                );
            }

            // ---- Collect Errors or Valid Data ----
            if (rowErrors.length > 0) {
                validationErrors.push({
                    row: rowNumber,
                    errors: rowErrors
                });
            } else {

                const parsedSOB = parseFloat(approvedSOB);

                const cleanedRow = {
                    rowNumber,
                    transporter_name: masterTransporter.transporter_name,
                    transporter_code: masterTransporter.transporter_code,
                    zone: hubName,
                    load: parsedSOB
                };

                cleanedData.push(cleanedRow);

                if (!hubMap[hubName]) {
                    hubMap[hubName] = {
                        total: 0,
                        rows: []
                    };
                }

                hubMap[hubName].total += parsedSOB;
                hubMap[hubName].rows.push(cleanedRow);
            }
        });

        // ---- REMOVE INVALID ROWS SET ----
        const invalidRowNumbers = new Set(
            validationErrors.map((e) => e.row)
        );

        // ---- HUB LEVEL VALIDATION (ONE ERROR PER HUB) ----
        Object.keys(hubMap).forEach((hub) => {

            // Loads are volumes - no 100 cap (that rule belongs to the approved-share upload).
            if (false) {

                overPercentErrors.push({
                    hub: hub,
                    error: `Total Approved SOB for Hub "${hub}" exceeds 100 (Current Total: ${hubMap[hub].total})`
                });

                // mark rows invalid
                hubMap[hub].rows.forEach((row) => {
                    invalidRowNumbers.add(row.rowNumber);
                });
            }
        });

        // ---- FILTER VALID ROWS ----
        cleanedData = cleanedData.filter(
            (row) => !invalidRowNumbers.has(row.rowNumber)
        );

        // ---- FINAL DATA ----
        const finalData = cleanedData.map(({ rowNumber, ...rest }) => rest);

        setErrors(validationErrors);
        setOverErrors(overPercentErrors);
        setValidData(finalData);

        console.log("Validation Errors:", validationErrors);
        console.log("Over Percent Errors:", overPercentErrors);
        console.log("Valid Data:", finalData);
    };
    const checkHubIdentity = (name) => {
        const uniqueHubs = [...new Set(hubCityData.map(e => e.hub_name))];
        return uniqueHubs.includes(name);
    };

    const isValidNumber = (value) => {
        const str = String(value || "").trim();
        return str !== "" && /^\d+(\.\d+)?$/.test(str);
    };

    var errTrueUpload = errors.length > 0 && validData.length > 0
    var disableUpload = (validData.length == 0 || overErrors.length > 0)

    const getShortFileName = (name, maxLength = 31) => {
        const lastDot = name.lastIndexOf(".");
        const baseName = name.substring(0, lastDot);
        const extension = name.substring(lastDot);

        if (baseName.length <= maxLength) return name;

        return baseName.substring(0, maxLength) + "..." + extension;
    };

    const handlerTime = (event, name) => {
        var d = new Date(event._d);

        var date = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + (d.getDate());

        // this.setState({
        //     valid_from: valid_from
        // });
        setTimeData((prevState) => ({
            ...prevState,
            [name]: date
        }))
    }

    const addNewHubSOB = () => {
        // var cityArray = this.state.cityList.map((each) => ({ label: each.city, value: each.city, state: each.state }));
        // var stateArray = this.state.statesList.map((each) => ({ label: each, value: each }));
        // var vehicleCapacityArray = this.state.vehicleCap.map((each) => ({ label: each, value: each }));
        var transporterArray = transporterData.map((each) => ({ label: each.transporter_name, value: each.transporter_code }));
        const uniqueHubs = [...new Set(hubCityData.map(e => e.hub_name))];
        var clubbingResourceArray = [
            {
                id: 1,
                title: "Valid From",
                field: "valid_from",
                type: "date",
                inputData: { placeholder: "Select Date", name: "valid_from", dateFormat: "YYYY-MM-DD" },
                errMsg: "Please select the Valid From",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 2,
                title: "Valid To",
                field: "valid_to",
                type: "date",
                inputData: { placeholder: "Select Date", name: "valid_to", dateFormat: "YYYY-MM-DD" },
                errMsg: "Please select the Valid To",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 3,
                title: "Transporter",
                field: "transporter_code",
                type: "dropdown",
                optionsArray: transporterArray,
                errMsg: "Please Select Transporter.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            ...uniqueHubs.map((hub, index) => ({
                id: 4 + index,
                title: `${hub} SOB ( % )`,
                field: hub,
                type: "dropdown",
                optionsArray: transporterArray,
                errMsg: "Please Select Transporter.",
                is_active: true,
                is_disabled: false,
                is_required: true
            }))
        ];
        var titleLabel = "Add New Hub SOB"
        this.setState({
            controller: {
                open: true,
                title: titleLabel,
                btnType: "Add",
                formResourceArray: clubbingResourceArray,
                type: "add",
                formData: {}
            }
        })
    }
    const onClickSubmit = async (code) => {
        setLoadshow("show-m")
        setOverly("show-m")
        var transporter = await getTransportersData(code);
        var hubCity = await getHubCityData(code);
        var sobData = await getHubSOBData(code);
        createColumnDefs(transporter, hubCity);
        createRows(transporter, hubCity, (sobData && sobData.loadShareData) || [],
                   (sobData && sobData.zoneTotals) || []);
        setLoadshow("show-n")
        setOverly("show-n")
    }

    useEffect(() => {
        if (portContext.loading_port_code !== lastPortRef.current) {
            lastPortRef.current = portContext.loading_port_code;
            onGlobalPortChange(portContext.loading_port_code);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [portContext.loading_port_code]);

    const onGlobalPortChange = async (selectedPlant) => {
        if (!selectedPlant || !loadingPortData.some((each) => each.value == selectedPlant)) { return; }
        setLoadshow("show-m");
        setOverly("show-m");
        setLoadingPortCode(selectedPlant);
        await onClickSubmit(selectedPlant);
        setValidData([]);
        setErrors([]);
        setOverErrors([]);
        setShowBulkSlider(false);
        setBulkFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        setLoadshow("show-n");
        setOverly("show-n");
    };

    return (
        <div className="hub-master-container d-flex flex-column card col-xl-12" style={{ flex: "1 1 0%", minHeight: 0, margin: "0px", padding: "15px", overflowY: "auto" }}>

            {/* HEADER */}
            <div className="master-header">
                <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                    <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                    <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px" }}>Actual SOB Percentage</h5>
                </div>
            </div>


            {/* GRID */}
            <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", padding: "0 10px" }}>
                <div className="ag-theme-balham grid-wrapper mt-3 mb-2" style={{ flex: 1, minHeight: 0 }}>
                    <AgGridReact
                        ref={gridRef}
                        modules={modules}
                        rowData={calculatedData}
                        columnDefs={columnDefs}
                    defaultColDef={{
                        sortable: true,
                        filter: true,
                        floatingFilter: true
                    }}
                    statusBar={{
                        statusPanels: [
                            { statusPanel: "agSelectedRowCountComponent", align: "left" },
                            { statusPanel: "agFilteredRowCountComponent", align: "right" },
                            { statusPanel: "agTotalRowCountComponent", align: "right" }
                        ]
                    }}
                    animateRows
                    rowHeight={45}
                    headerHeight={45}
                    frameworkComponents={components}
                    onSelectionChanged={() => {
                        if (gridRef && gridRef.current && gridRef.current.api) {
                            const selected = gridRef.current.api.getSelectedRows();
                            setSelectedRows(selected);
                        }
                    }}
                    pinnedBottomRowData={totalRowData || []}
                />
                </div>
            </div>

            {/* OVERLAY */}
            {showSlider && (
                <div
                    className="slider-overlay"
                    onClick={closeSlider}
                />
            )}
            {showBulkSlider && (
                <div
                    className="slider-overlay"
                    onClick={() => {
                        setValidData([])
                        setTimeData((prevState) => ({ ...prevState, valid_from: "", valid_to: "" }))
                        setFileName("")
                        setErrors([])
                        setOverErrors([]);
                        setShowBulkSlider(false);
                        setBulkFile(null);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                    }}
                />
            )}

            {/* RIGHT SLIDER */}
            <div className={`hub-slider ${showSlider ? "open" : ""} d-flex flex-column`}>

                <div className="slider-header">
                    {`${cityList[0]} Hub Cities`}
                    <span onClick={closeSlider}>✕</span>
                </div>

                <div className="slider-body flex-grow-1 pt-4">
                    {cityList.slice(1,).map((each) => {
                        return <p className="font-bold" style={{ color: "#000", fontWeight: "bold" }}>{each}</p>
                    })}

                </div>
                <div className="slider-footer d-none">
                    <button
                        className="save-btn" style={{ margin: "0px" }}
                        onClick={""}
                    >
                        {editIndex !== null ? "Update" : "Save"}
                    </button>
                </div>
            </div>

            <div className={`hub-slider ${showBulkSlider ? "open" : ""} d-flex flex-column`}>

                <div className="slider-header">
                    Bulk Upload Hub
                    <span onClick={() => setShowBulkSlider(false)}>✕</span>
                </div>

                <div className="slider-body flex-grow-1">
                    <p className="mb-1" style={{ fontSize: "12px", color: "#555" }}>
                        Hub actual load: columns Transporter Code, Hub, Load (CMT).
                        The file replaces the current hub load share of this warehouse.
                    </p>
                    <input
                        ref={fileInputRef}
                        type="file"
                        accept=".xlsx,.xls,.csv"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                    />
                    {/* Upload button */}
                    <div className="d-flex align-items-center gap-3 mt-3">
                        <button
                            className="btn btn-info d-flex justify-content-center p-3"
                            type="button"
                            onClick={() => fileInputRef.current.click()}
                        >
                            Upload File
                        </button>

                        <button type="button" className="btn btn-secondary d-flex justify-content-center ml-3 p-3 flex-grow-1"
                            onClick={() => {
                                const ws = XLSX.utils.aoa_to_sheet([["Transporter Code", "Hub", "Load"]]);
                                const wb = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(wb, ws, "Hub Load Share");
                                XLSX.writeFile(wb, "hub_load_share_template.xlsx");
                            }}>
                            Download Sample Template
                        </button>
                    </div>

                    {fileName && (
                        <div style={{ marginTop: "15px", display: "flex", gap: "6px", maxWidth: "410px" }}>
                            <span>Selected File :</span>
                            <span
                                style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    flex: 1,
                                    fontWeight: "bold"
                                }}
                                title={fileName}
                            >
                                {getShortFileName(fileName)}
                            </span>
                        </div>
                    )}

                    {overErrors.length > 0 && <div>
                        <p className="text-danger" style={{ fontSize: "15px", fontWeight: "bold", color: "#000" }}>Hub Over Percentage Errors</p>
                        {overErrors.map((err, i) => (
                            <div key={i} style={{ color: "#000" }}>
                                <b>{err.hub}:</b> {err.error}
                            </div>
                        ))}
                    </div>}

                    {errors.length > 0 && (
                        <>
                            <h6 className="text-danger mt-3">Validation Errors</h6>

                            <div className="bg-primary" style={{ width: "100%" }}>
                                <table className="table-bordered mb-0 err-table" style={{ width: "100%", positive: "relative", height: "100%" }}>
                                    <thead className="table-light text-center"
                                    // style={{ positive: "sticky", zIndex: "100", backgroundColor: "#efefef" }}
                                    >
                                        <tr>
                                            <th style={{ width: "60px", padding: "9px 15px" }}>Row</th>
                                            <th>Error Description</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {errors.map((err, i) => (
                                            <tr key={i}>
                                                <td className="text-center" style={{ padding: "9px 15px" }}>
                                                    {err.row}
                                                </td>

                                                <td style={{ padding: "9px 15px", wordBreak: "break-word" }}>
                                                    {err.errors.map((e, idx) => (
                                                        <p className="m-0" key={idx}>{e}</p>
                                                    ))}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}

                </div>
                <div className="slider-footer">
                    <button
                        className="save-btn" style={{ margin: "0px", width: "auto", padding: "5px 25px", cursor: disableUpload && "not-allowed", opacity: disableUpload && "0.5" }}
                        onClick={handleBulkUpload}
                        disabled={disableUpload}
                    >
                        {errTrueUpload ? "Upload only valid data" : "Upload"}
                    </button>
                </div>

            </div>

            {/* {controller.open && (
                <>
                    <div
                        className="slider-overlay"
                        onClick={() => { setController((prevState) => ({ ...prevState, open: false })) }}
                    />
                    <AddEditController
                        resource={controller}
                        onUpdate={onUpdateHubSOB}
                    />
                </>
            )} */}

            <div className={"dataLoadpageimg " + (loadshow)}>
                <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
            </div>
            <div className={"overlay-part " + (overly)} onClick={onClickHideAll}></div>


        </div>
    );

};